export const getTimeZoneLabel = (time: Date): string => {
  const timeZoneOffset = time.getTimezoneOffset() / 60
  return timeZoneOffset < 0 ? `UTC+${Math.abs(timeZoneOffset)}` : `UTC-${Math.abs(timeZoneOffset)}`
}

export function formatDateToYYYYMMDD(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
